import React from "react";
import { MapPin } from "lucide-react";
import { SERVICE_CITIES } from "../lib/content";

const THEMES = {
  light: {
    wrap: "border border-brand bg-white",
    head: "text-brand-primary",
    sub: "text-brand-muted",
    chip: "bg-brand-light text-brand-primary border border-brand",
  },
  dark: {
    wrap: "border border-white/15",
    head: "text-white",
    sub: "text-slate-300",
    chip: "bg-white/5 text-slate-200 border border-white/10",
  },
};

export const ServiceArea = ({ t, theme = "light", testId = "service-area", compact = false }) => {
  const s = THEMES[theme];
  return (
    <div data-testid={testId} className={`${s.wrap} p-5 md:p-6`}>
      <div className={`flex items-center gap-2 font-display font-bold text-sm uppercase tracking-wide ${s.head}`}>
        <MapPin className="w-4 h-4 text-brand-accent flex-shrink-0" strokeWidth={2.5} />
        {t.area.basedIn}
      </div>
      <div className={`mt-2 text-xs font-display font-semibold uppercase tracking-wider ${s.sub}`}>
        {t.area.serving}
      </div>
      {compact ? (
        <p className={`mt-2 text-sm leading-relaxed ${s.sub}`}>
          {SERVICE_CITIES.join(" · ")} {t.area.surrounding}
        </p>
      ) : (
        <>
          <ul className="mt-3 flex flex-wrap gap-2">
            {SERVICE_CITIES.map((city) => (
              <li key={city} className={`px-2.5 py-1 text-xs font-display font-semibold ${s.chip}`}>
                {city}
              </li>
            ))}
          </ul>
          <p className={`mt-3 text-sm ${s.sub}`}>{t.area.surrounding}</p>
        </>
      )}
    </div>
  );
};
